exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.hideUpload > div {\n  display: none;\n}\n", ""]);

// exports
